export default "__VITE_ASSET__YP0RruEt__"